/* eslint-disable prettier/prettier */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import {
  getAllFacilityCountBymonth,
  getAllFacilitytBymonth,
  getAllGuestBymonth,
  getAllTotalCount,
  getAllTotalSupportBuisnessCount,
  getDashboardTableData,
  getDownloadTableData,
  getTotalBookings,
} from '../../../services/dashboard';
import { IDashbord } from '../interface';
// import { IDashbord } from '../interface';

const initialState: IDashbord = {
  isGetNoOfGuestByMonth: false,
  allGuestByMonthList: [],
  isGetNoOfFacilityByMonth: false,
  allGuestByLocationList: [],
  isGetNoOfFacilityCountByMonth: false,
  allFacilitiesCountByMonth: [],
  isGetTotalCount: false,
  allTotalCount: [],
  isGetTotalSupportBuisness: false,
  allTotalCountSupprtBuisness: [],
  isTotalBookingsLoading: false,
  TotalBookings: {
    data: [],
  },
  tableSummary: {
    data: [],
  },
  istableSummaryFetching: false,
  istableSummarydownloading: false,
};

export const dashboardGraphInfoSlice = createSlice({
  name: 'dashboardGraphInfo',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(fetchAllGuestByMonth.pending, (state) => {
        state.isGetNoOfGuestByMonth = true;
      })
      .addCase(fetchAllGuestByMonth.fulfilled, (state, action) => {
        state.isGetNoOfGuestByMonth = false;
        state.allGuestByMonthList = action.payload.data;
      })
      .addCase(fetchAllGuestByMonth.rejected, (state) => {
        state.isGetNoOfGuestByMonth = false;
      })
      .addCase(fetchAllLocationtByMonth.pending, (state) => {
        state.isGetNoOfFacilityByMonth = true;
      })
      .addCase(fetchAllLocationtByMonth.fulfilled, (state, action) => {
        state.isGetNoOfFacilityByMonth = false;
        state.allGuestByLocationList = action.payload.data;
      })
      .addCase(fetchAllLocationtByMonth.rejected, (state) => {
        state.isGetNoOfFacilityByMonth = false;
      })
      .addCase(fetchAllFacilityCountByMonth.pending, (state) => {
        state.isGetNoOfFacilityCountByMonth = true;
      })
      .addCase(fetchAllFacilityCountByMonth.fulfilled, (state, action) => {
        state.isGetNoOfFacilityCountByMonth = false;
        state.allFacilitiesCountByMonth = action.payload.data;
      })
      .addCase(fetchAllFacilityCountByMonth.rejected, (state) => {
        state.isGetNoOfFacilityCountByMonth = false;
      })
      .addCase(fetchAllTotalCountDetails.pending, (state) => {
        state.isGetTotalCount = true;
      })
      .addCase(fetchAllTotalCountDetails.fulfilled, (state, action) => {
        state.isGetTotalCount = false;
        state.allTotalCount = action.payload.data;
      })
      .addCase(fetchAllTotalCountDetails.rejected, (state) => {
        state.isGetTotalCount = false;
      })
      .addCase(totalSupportBuisneessByMonth.pending, (state) => {
        state.isGetTotalSupportBuisness = true;
      })
      .addCase(totalSupportBuisneessByMonth.fulfilled, (state, action) => {
        state.isGetTotalSupportBuisness = false;
        state.allTotalCountSupprtBuisness = action.payload.data;
      })
      .addCase(totalSupportBuisneessByMonth.rejected, (state) => {
        state.isGetTotalSupportBuisness = false;
      })
      .addCase(getTotalBookingInDashBoard.pending, (state) => {
        state.isTotalBookingsLoading = true;
      })
      .addCase(getTotalBookingInDashBoard.fulfilled, (state, action) => {
        state.isTotalBookingsLoading = false;
        state.TotalBookings.data = action?.payload?.data;
      })
      .addCase(getTotalBookingInDashBoard.rejected, (state) => {
        state.isTotalBookingsLoading = false;
      })
      .addCase(getTableData.pending, (state) => {
        state.istableSummaryFetching = true;
      })
      .addCase(getTableData.fulfilled, (state, action) => {
        state.istableSummaryFetching = false;
        state.tableSummary.data = action?.payload?.data;
      })
      .addCase(getTableData.rejected, (state) => {
        state.istableSummaryFetching = false;
      })

      .addCase(downloadTableData.pending, (state) => {
        state.istableSummarydownloading = true;
      })
      .addCase(downloadTableData.fulfilled, (state) => {
        state.istableSummarydownloading = false;
      })
      .addCase(downloadTableData.rejected, (state) => {
        state.istableSummarydownloading = false;
      });
  },
});

export const fetchAllGuestByMonth = createAsyncThunk(
  'user/getAllGuest',
  async () => {
    const response = await getAllGuestBymonth();
    return response;
  }
);
export const fetchAllLocationtByMonth = createAsyncThunk(
  'user/get-location',
  async () => {
    const response = await getAllFacilitytBymonth();
    return response;
  }
);
export const fetchAllFacilityCountByMonth = createAsyncThunk(
  'user/get-facility-count',
  async () => {
    const response = await getAllFacilityCountBymonth();
    return response;
  }
);
export const fetchAllTotalCountDetails = createAsyncThunk(
  'user/get-total-count',
  async () => {
    const response = await getAllTotalCount();
    return response;
  }
);
export const totalSupportBuisneessByMonth = createAsyncThunk(
  'user/get-total-count-support-buisness',
  async () => {
    const response = await getAllTotalSupportBuisnessCount();
    return response;
  }
);
export const getTotalBookingInDashBoard = createAsyncThunk(
  'dashboardGraphInfoSlice/get-total-bookings',
  async ({
    month,
    currency,
    facilityId,
  }: {
    month: string;
    currency: string;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      currency: string;
      facilityId?: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      currency,
    };
    if (facilityId != '') {
      params.facilityId = facilityId;
    }
    const response = await getTotalBookings(params);
    return response;
  }
);
export const getTableData = createAsyncThunk(
  'dashboardGraphInfoSlice/get-table-data',
  async ({
    month,
    searchTerm,
    filter,
    page,
    facilityId,
  }: {
    month: string;
    searchTerm: string;
    filter: string;
    page: number;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      searchTerm: string;
      bookingStatus?: string;
      size: number;
      page: number;
      facilityId?: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      searchTerm,
      size: 5,
      page,
    };
    if (facilityId != '') {
      params.facilityId = facilityId;
    }
    if (filter !== '') {
      params.bookingStatus = filter;
    }
    const response = await getDashboardTableData(params);
    return response;
  }
);
export const downloadTableData = createAsyncThunk(
  'dashboardGraphInfoSlice/download-table-data',
  async ({
    month,
    searchTerm,
    filter,
    facilityId,
  }: {
    month: string;
    searchTerm: string;
    filter: string;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      searchTerm: string;
      bookingStatus?: string;
      facilityId?: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      searchTerm,
    };
    if (facilityId != '') {
      params.facilityId = facilityId;
    }
    if (filter !== '') {
      params.bookingStatus = filter;
    }

    const response = await getDownloadTableData(params);

    return response;
  }
);
export const dashboardInfo = (state: RootState) => state.dasboardInfo;

export const dashboardInfoReducer = dashboardGraphInfoSlice.reducer;
